import React from 'react';
import { motion } from 'framer-motion';

const HeartLogo = ({ className = "w-10 h-10", animate = false }) => {
  const logoVariants = {
    initial: { scale: 1 },
    animate: {
      scale: [1, 1.02, 1],
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  return (
    <motion.div
      className={className}
      variants={animate ? logoVariants : {}}
      initial="initial"
      animate={animate ? "animate" : "initial"}
    >
      <img
        src="/images/nyquist_logo.png"
        alt="Nyquist Therapeutics"
        className="w-full h-full object-contain"
      />
    </motion.div>
  );
};

export default HeartLogo;
